export default __webpack_public_path__ + "locales/cs/SharingPanel.json?hash=9af7d42acffeb2bcafe012dcbd78f4e2";